<tds-modal [size]="size" [id]="modalId" [header]="title" [show]="modalService.showModal">
  <p slot="body">
    {{ message }}
  </p>
  <div slot="actions">
    <tds-button
      data-dismiss-modal
      class="tds-u-mr1"
      size="sm"
      text="{{ confirmationButtonMsg }}"
      (click)="modalService.sendConfirmation()"
    />
    <tds-button data-dismiss-modal size="sm" text="{{ cancelationButtonMsg }}" />
  </div>
</tds-modal>
